// extracted by mini-css-extract-plugin
export default {"footerCafeteria":"style_footerCafeteria__yI3tw","itemsFooter":"style_itemsFooter__K7BFb","iconsFooter":"style_iconsFooter__BXM6v","footerLogo":"style_footerLogo__OZ9b0"};